module.exports = __webpack_public_path__ + "img/shop-search.svg";